awardCalculation.classy.controller({
    name: 'BusinessIncomeController',
    inject: ['$scope', 'ApplicationService', 'CalculationService'],
    init: function() {
        this.$.ApplicationService = this.ApplicationService;
        if (this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 == "")
            this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 = 0;
        this.$.verifiedAnnualIncome = this.annualIncome();
        this.$.CalculationService = this.CalculationService;
        this.CalculationService.reCalc();
        this.$.incomelabel = this.ApplicationService.getIncomeLabel();


        //this.ApplicationService.getFamilyData().edit_sums.Inc_Estate
        //this.ApplicationService.getFamilyData().taxQueue[0].taxStatus = Number(this.ApplicationService.getFamilyData().taxQueue[0].taxStatus);
        this.$.incomeNeededForHousing = this.ApplicationService.getFamilyData().awardData.housing.housing/.3

        this.$.businessIncomeForHousing = (this.$.incomeNeededForHousing - this.$.verifiedAnnualIncome - this.ApplicationService.getFamilyData().edit_sums.Inc_Estate  < 0) ?
            0 :  this.$.incomeNeededForHousing - this.$.verifiedAnnualIncome - this.ApplicationService.getFamilyData().edit_sums.Inc_Estate;
    },
    annualIncome: function() {
        var inc1 = this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 ? this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_1 : 0;
        var inc2 = this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 ? this.ApplicationService.getFamilyData().edit_sums.Inc_Annual_2 : 0;
        return parseInt(inc1) +  parseInt(inc2);
    },
    netBusinessIncome: function() {
        if (this.ApplicationService.getFamilyData().bizIncLines.length>0 && this.ApplicationService.getFamilyData().data[0].Fam_Country === "United States") {
            return parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line12']) +
                parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line17']) +
                parseInt(this.ApplicationService.getFamilyData().bizIncLines[0]['line18']);
        } else if (this.ApplicationService.getFamilyData().data[0].Fam_Country === "Canada")  {
            return parseInt(this.ApplicationService.getFamilyData().ism_edits.ISM_Business);
        } else {
            return 0;
        }
    }
});
